import React, { Component } from 'react';
import './MainMenu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWalking, faFilter, faCity, faBook} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import MenuType from '../enums/MenuType';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
export default class MainMenu extends Component {
	constructor(props){
		super(props);
		const {showMainMenu} = props;
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._showMainMenu = showMainMenu;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._handleClickFilter=this._handleClickFilter.bind(this);
		this._handleClickSite = this._handleClickSite.bind(this);
		this._handleClickBrochure = this._handleClickBrochure.bind(this);
		this._iMenuManager  = null;
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this.state = {visible:false};
	}
	show(){
		this.setState({visible:true});
		this._iMenuManager.showMe(this);
		this._clickedOffManager.register();
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.MAIN_MENU;
	}
	_handleClickFilter(){
		this._iMenuManager.showMenuByType(MenuType.FILTERS);
	}
	_handleClickSite(){
		this._iMenuManager.showMenuByType(MenuType.SITE_PICKER);
	}
	_handleClickBrochure(){
		this._iMenuManager.showMenuByType(MenuType.BROCHURE_GENERATION);
	}
	render() {
		let className = "main-menu menu";
		if(this.state.visible)
			className+= " visible";
		return (
			<div className={className}>
				<SubMenuHeader ref={this._subMenuHeader}></SubMenuHeader>
				<div className="row" ref={this._element}>
					<IconButton faIcon={faFilter} text="Filters" onClick={this._handleClickFilter}></IconButton>
					<IconButton faIcon={faCity} text="Site" onClick={this._handleClickSite}></IconButton>
					<IconButton faIcon={faBook} text="Brochure" onClick={this._handleClickBrochure}></IconButton>
				</div>
			</div>
		)
	}
}